<template>
  <v-col>
    <h3>
      <template v-if="isEditing">
        Editing Bill
      </template>
      <template v-else>
        Add New Bill
      </template>
    </h3>
    <v-row>
      <v-col
        cols="12"
        md="8"
        sm="4"
      >
        <v-card outlined>
          <v-card-text>
            <div>Customer Information</div>
            <v-row>
              <v-col
                cols="12"
                md="12"
                sm="12"
              >
                <v-text-field
                  v-model="form.name"
                  hide-details="auto"
                  label="Full Name"
                  outlined
                  dense
                  :error-messages="errors.getMessage('name')"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.description"
                  label="Description"
                  outlined
                  rows="2"
                  dense
                  :error-messages="errors.getMessage('description')"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card
          class="mt-5"
          outlined
        >
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="6"
              >
                <v-text-field
                  v-model="item.name"
                  hide-details="auto"
                  label="Item Name"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                sm="6"
              >
                <v-text-field
                  v-model="item.qty"
                  hide-details="auto"
                  label="QTY"
                  outlined
                  type="number"
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                sm="6"
              >
                <v-text-field
                  v-model="item.price"
                  hide-details="auto"
                  label="Price"
                  outlined
                  type="number"
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="6"
              >
                <v-text-field
                  v-model="item.imei"
                  hide-details="auto"
                  label="IMEI"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="6"
              >
                <v-text-field
                  v-model="item.sNumber"
                  hide-details="auto"
                  label="SN"
                  outlined
                  dense
                />
              </v-col>

              <v-col
                cols="12"
                md="12"
                sm="6"
              >
                <v-btn
                  class="info"
                  :disabled="checking"
                  @click="addItem"
                >
                  Add
                </v-btn>
                <v-btn
                  class="error ml-1"
                  @click="clearItems"
                >
                  Undo
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Item Name
                    </th>
                    <th class="text-left">
                      IMEI
                    </th>
                    <th class="text-left">
                      SN
                    </th>
                    <th class="text-left">
                      QTY
                    </th>
                    <th class="text-left">
                      Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in form.items"
                    :key="item.name"
                  >
                    <td>{{ item.name | capitalize }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item.sNumber }}</td>
                    <td>{{ item.qty }}</td>
                    <td>{{ item.price | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="12"
      >
        <v-card outlined>
          <v-card-text>
            <v-col>
              <v-text-field
                v-model="form.date"
                hide-details="auto"
                label="Date"
                outlined
                type="date"
                dense
                :error-messages="errors.getMessage('date')"
              />
            </v-col>

            <v-col>
              <v-text-field
                v-model="form.time"
                hide-details="auto"
                label="Time"
                outlined
                type="time"
                dense
                :error-messages="errors.getMessage('time')"
              />
            </v-col>

            <v-col>
              <v-text-field
                v-model="form.charges"
                hide-details="auto"
                label="Charges"
                outlined
                dense
                type="number"
                :error-messages="errors.getMessage('charges')"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.taxRate"
                hide-details="auto"
                label="Tax Rate %"
                outlined
                dense
                type="number"
                :error-messages="errors.getMessage('taxRate')"
              />
            </v-col>

            <h2>Total : {{ afterTax | currency }}</h2>
          </v-card-text>
        </v-card>
        <div class="text-center">
          <v-btn
            color="green"
            class="ma-2 white--text"
            @click="submitBill"
          >
            Save
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      isEditing: false,
      item: {},
      form: {
        date: new Date().toISOString().substr(0, 10),
        charges: 0,
        taxRate: 0,
        items: [],
        time: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
    checking() {
      const item = this.$data.item;
      return !item.name || !item.qty || !item.price;
    },
    charges() {
      let value = 0;
      this.$data.form.items.forEach((item) => {
        value += Number(item.price);
      });
      return value;
    },

    afterTax() {
      const info = this.$data.form;
      let Tax = info.charges * (info.taxRate / 100);
      return Number(info.charges) + Number(Tax);
    },
  },
  watch: {
    item() {
      this.$data.form.charges = this.charges;
    },
  },
  mounted() {
    const date = new Date();
    let time = date.getHours() + ":" + date.getMinutes();
    this.$data.form.time = time;
    if (this.$route.params.id) {
      window.axios.get("/bill/" + this.$route.params.id).then((response) => {
        this.$data.form = response.data.bill;
        this.isEditing = true;
      });
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    clearItems() {
      this.$data.form.items = [];
    },
    addItem() {
      this.$data.form.items.push(this.$data.item);
      this.$data.item = {};
    },
    submitBill() {
      this.$data.form.charges = this.afterTax;
      this.$data.form.due = this.due;
      if (this.isEditing) {
        this.updateBill();
      } else {
        this.addBill();
      }
    },
    updateBill() {
      window.axios
        .patch("/bill/" + this.$route.params.id, this.$data.form)
        .then((response) => {
          this.feedback(response.data.message);
          this.$router.push({ name: "BillList" });
        });
    },
    addBill() {
      window.axios.post("/bill", this.$data.form).then((response) => {
        this.feedback(response.data.message);
        this.$router.push({
          name: "BillPrint",
          params: { id: response.data.bill },
        });
      });
    },
  },
};
</script>
